
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
export const IdleTimer = () => {
const cookies = new Cookies();

  const handleOnIdle = () => {
    cookies.remove('userEmail',{ path: '/' });
    cookies.remove("i18nextLng",{ path: '/' });
    window.location.href ="/logout"
  };

  useIdleTimer({
    timeout: 1000 * 60 * 100,
    onIdle: handleOnIdle
  });
  
};

//export default IdleTimer;